// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    background-color: #f0f0f0; 
}

.main-container {
    width: 100%;
    height: calc(100vh - 80px); 
    display: flex;
    flex-direction: column;
    background-color: inherit; 
}
 
.fixed-header {

    left: 0;
    top: 6%;
    padding: 0.5rem; 
    
    font-size:22px;
}
.plant-header {
    font-size: 22px;
    width: 30vw; 
    margin-bottom:1rem;

} 



/* yield overview */
.main-div {
    padding: 1rem; 
    width: 58vw;
    margin-top: -1%; 
    border-radius: 20px;
    background-color:white;
    display: flex;
    justify-items: center;
    align-items: center;
}

.card-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr); 
    gap: 1rem;
    justify-items: center;
    align-items: center;
}

.item1 {
    background-color:#FBD1D1;
    padding: 1rem; 
    text-align: center;
    width: 13vw; 
    min-height: 12vh; 
    border-radius: 15px;
    font-weight: bold;
    font-size: 17px;
    
}

.item2 {
    background-color: blanchedalmond;
    padding: 1rem; 
    text-align: center;
    width: 13vw; 
    min-height: 12vh; 
    border-radius: 15px;
    font-weight: bold;
    font-size: 17px;
}
.item3 {
    background-color:rgb(212, 243, 243);
    padding: 1rem; 
    text-align: center;
    width: 13vw; 
    min-height: 12vh; 
    border-radius: 15px;
    font-weight: bold;
    font-size: 17px;
}
.item4 {
    background-color:rgb(248, 231, 248);
    padding: 1rem; 
    text-align: center;
    width: 13vw; 
    min-height: 12vh; 
    border-radius: 15px;
    font-weight: bold;
    font-size: 17px;
}

.alarm-div{
    margin-top:1%;
    margin-left: 1%;
    width: 57vw;
    height:28vw; 
    border-radius: 15px;
    background-color: white;
    justify-content: center;
    text-align: center;
  }

  .alarm-container {
    padding: 20px;
    background-color: white; 
    border-radius: 15px;
  }
  
 
  .alarm-header h6 {
    font-size: 18px;
    font-weight: bold;
   
  }
  
  .alarm-grid {
    display: grid;
 
    grid-template-columns: repeat(4, 1fr); 
    gap: 15px;
  }
  
  .alarm-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-radius: 8px;
    background-color: #f0f0f0;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .alarm-item span {
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  
  .alarm-icon {
    width: 15px;
    height: 15px;
    margin-right: 8px;
  }
  .flow-diagram{
    margin-top:-24%;
    margin-left: 4%;
    width: 45vw;
    height:20vw;
    background-color:white;
   
  }
  .flow-dgm{
    margin-top:-1%;
    margin-left: 1%;
    width: 57vw;
    height:29vw;
    background-color:white;
   
  }
 
  .env-benefits{
    margin-top:4.5%;
    margin-left: 1%;
     width: 57vw;
    height:7vw;
    /* background-color: rgb(203, 252, 236); */
    background-color: white;
    border-radius: 15px;
    justify-content: center;
    text-align: center;
        
     }
     .environ-benefits{
      margin-top:1%;
    margin-left: 1%;
     width: 57vw;
    height:7vw;
 
    background-color: white;
    border-radius: 15px;
    justify-content: center;
    text-align: center;
          
       }
      

      .env-header {
        text-align: left;
        margin-bottom: 1rem;
        margin-left:2%;
        font-size: 16px;
        /* font-weight: bold; */
    }
    
    .EB-container {
        display: flex;
        /* justify-content: space-between; 
        align-items: flex-start; */
        gap: 6.4rem; 
    }
    
    .EB-item {
        display: flex;
        align-items: center;
        gap:0.5rem; 
    }
    
    .values-column {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    
    .value {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 0.2rem; 
    }
    
    .label {
        font-size: 12px;
        color: #555;
    }
    

      .EB-image-row {
        display: flex;
        gap: 50px; 
        margin-left:10px;
      }
      
      .EB-image-row img {
        width: 50px;
        height: 50px;
        margin-left:1px;
      } 

  .main-div2{
    padding: 0.5rem; 
    width: 40vw;
    margin-top: -46%;
    margin-left: 47rem; 
    background-color:white;
    border-radius: 15px;
}
.main-temp{
   /* background-color:rgb(129, 129, 228); */
  background-color: #a8d5e4;
  border-radius: 10px;
  font-size: 14px;
  padding:8px;
  font-weight: bold;
}
.main-div3{
    padding: 0.5rem;
    margin-top:1.5%;
    width: 40vw;
    margin-left: 47rem;  
    background-color:white;
    border-radius: 15px;
}
  .day-graph1{
    width:100%;
    
  }

  .chart-container {
    width: 100%;
}
  
  .date-picker-container {
    display: flex;
    align-items: center;
  
}

.date-picker-label {
    font-weight: bold;
    margin-right: 1rem;
}

.styled-date-picker {
    padding: 0.1rem 2rem;
    font-size: 14px;
    border: 2px solid #ddd;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: border-color 0.3s, box-shadow 0.3s;
}

.styled-date-picker:hover {
    border-color: #999;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.styled-date-picker:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.dropdown-container{
    margin-top: 1px;
    
    
}
.styled-dropdown{
    height:30px;
    padding: 0.1rem 2rem;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
   
}
.date-picker-container,
.dropdown-container {
    display: inline-block;
    margin-right: 10px; 
}

.date-picker-dropdown-container {
    display: flex;
    align-items: center; 
}



/* graph */
.energy-value-container {
    display: flex;
    flex-direction: row; 
    align-items: center; 
    gap: 10px; 
    /* background-color: #f0f0f0; */
    margin-top:1%;
    color:blue;
    
}

.energy-value-container h6 {
    margin-left: 6%; 
    padding: 1px;
    font-size: 15px;
    font-weight:bold; 
}

.energy-value-container .energy-label {

    font-weight: normal; 
    
}


@media only screen and (min-width: 1403px) {
  .main-div2{
    padding: 0.5rem; 
    width: 40vw;
    margin-top: -46%;
    margin-left: 52rem; 
    background-color:white;
    border-radius: 15px;
}
.main-div3{
    padding: 0.5rem;
    margin-top:1.4%;
    width: 40vw;
    margin-left: 52rem;  
    background-color:white;
    border-radius: 15px;
}

}


@media only screen and (min-width: 1540px) {
  .main-div2{
    padding: 0.5rem; 
    width: 40vw;
    margin-top: -45%;
    margin-left: 59rem; 
    background-color:white;
    border-radius: 15px;
}
.main-div3{
    padding: 0.5rem;
    margin-top:1.4%;
    width: 40vw;
    margin-left: 59rem;  
    background-color:white;
    border-radius: 15px;
}

}


@media only screen and (min-width: 1684px) {
  .main-div2{
    padding: 0.5rem; 
    width: 40vw;
    margin-top: -45%;
    margin-left: 62.5rem; 
    background-color:white;
    border-radius: 15px;
}
.main-div3{
    padding: 0.5rem;
    margin-top:1.2%;
    width: 40vw;
    margin-left: 62.5rem;  
    background-color:white;
    border-radius: 15px;
}

}
@media only screen and (min-width: 1874px) {
  .main-div2{
    padding: 0.5rem; 
    width: 40vw;
    margin-top: -45%;
    margin-left: 70.5rem; 
    background-color:white;
    border-radius: 15px;
}
.main-div3{
    padding: 0.5rem;
    margin-top:1.2%;
    width: 40vw;
    margin-left:70.5rem;  
    background-color:white;
    border-radius: 15px;
}
}


@media only screen and (min-width: 2530px) {
  .main-div2{
    padding: 0.5rem; 
    width: 40vw;
    margin-top: -45%;
    margin-left: 94rem; 
    background-color:white;
    border-radius: 15px;
}
.main-div3{
    padding: 0.5rem;
    margin-top:1.2%;
    width: 40vw;
    margin-left: 94rem;  
    background-color:white;
    border-radius: 15px;
}

}

@media only screen and (min-width: 3796px) {
  .main-div2{
    padding: 0.5rem; 
    width: 40vw;
    margin-top: -42%;
    margin-left: 140rem; 
    background-color:white;
    border-radius: 15px;
}
.main-div3{
    padding: 0.5rem;
    margin-top:1.2%;
    width: 40vw;
    margin-left: 140rem;  
    background-color:white;
    border-radius: 15px;
}

}
@media only screen and (min-width: 5061px) {
  .main-div2{
    padding: 0.5rem; 
    width: 40vw;
    margin-top: -42%;
    margin-left: 188rem; 
    background-color:white;
    border-radius: 15px;
}
.main-div3{
    padding: 0.5rem;
    margin-top:1.2%;
    width: 40vw;
    margin-left: 188rem;  
    background-color:white;
    border-radius: 15px;
}

}



/* 

@media only screen and (min-width: 1684px) {
  
  .plant-header {
    font-size: 28px;
    width: 30vw; 
    margin: 0; 
} 
.main-div {
  padding: 1.2rem; 
  width: 35vw;
  margin-top: -1%; 
  border-radius: 20px;
}
.item {
    background-color: white;
    padding: 1rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 20px;
    font-weight: bold;
    font-size: 24px;
}

.main-div3 {
  margin-top: -29.5%; 
  width: 47vw; 
}

.env-benefits{
  margin-top:-20%; 
  border-radius: 20px;     
   }
.coal ,.co2, .ETP{
    font-size:14px;
    justify-content: center;
    text-align: center;
}

.values-row {
    display:flex;
    justify-content: center;
    text-align: center;
    gap: 60px; 
    margin-top:5px;
    font-weight: bold;
  
  }
  
  .text-row {
    display: flex;
    gap: 14px; 
    margin-top: 3px; 
    margin-left: 10px;
  }
  .text-row .co2{
    margin-left: 60px;
  }
  .text-row .ETP{
    margin-left: 38px;
  }
  .EB-image-row {
    display: flex;
    gap: 64px; 
    margin-left:20px;
  }
  
  .EB-image-row img {
    width: 52px;
    height: 50px;
    margin-left:10px;
  } 
  .alarm-div{
    margin-top:-10%;
    margin-left: 36%;
    width: 22vw;
    height:9vw;
    
    border-radius: 12px;
    justify-content: center;
    text-align: center;
    
  }
  .alarm-container {
    padding: 3px;
    border: 3px solid #ccc;
    border-radius: 10px;
    
  }
  
 
  .alarm-header h6 {
    font-size: 21px;
    font-weight: bold;
   
  }
  
  .alarm-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;
  }
  
  .alarm-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border-radius: 9px;
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .alarm-item span {
    font-size: 19px;
    font-weight: bold;
    color: #333;
  }
  
  .alarm-icon {
    width: 17px;
    height: 17px;
    margin-right: 9px;
  }

  .date-picker-container {
    display: flex;
    align-items: center;
    margin: 1rem 0;
}

.date-picker-label {
    font-weight: bold;
    margin-right: 1rem;
}

.styled-date-picker {
    padding: 0.7rem 1.2rem;
    font-size: 22px;
    border: 2px solid #ddd;
    border-radius: 7px;
  }

.dropdown-container{
    margin-top: 1px;   
}
.styled-dropdown{
    height:53px;
    padding: 0.5rem 1rem;
    font-size: 22px;
    border: 2px solid #ddd;
    border-radius: 7px;
    background-color: white;
    cursor: pointer;
   
}
.date-picker-container,
.dropdown-container {
    display: inline-block;
    margin-right: 10px; 
}
.energy-value-container {
    gap: 10px; 
    margin-top:-1%;
}

.energy-value-container h6 {
    margin-left: 10%; 
    padding: 1;
    font-size: 22px; 
}

}

@media only screen and (min-width: 1874px) {

  .plant-header {
    font-size: 29px;
    width: 30vw; 
    margin: 0; 
} 
.main-div {
  padding: 1.2rem; 
  width: 35vw;
  margin-top: -1%; 
  border-radius: 20px;
}
.item {
    background-color: white;
    padding: 1rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 20px;
    font-weight: bold;
    font-size: 25px;
}
  .main-div3 {
      margin-top: -31.5%; 
      width: 47vw; 
    
  }
  .flow-diagram{
    margin-top:-16%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-25%;  
    border-radius: 22px;
       
     }
  .coal ,.co2, .ETP{
      font-size:17px;
      justify-content: center;
      text-align: center;
  }
  .env-header{
    font-size:24px;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 60px; 
      margin-top:5px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 12px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 58px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 65px; 
      margin-left:20px;
    }
    
    .EB-image-row img {
      width: 58px;
      height: 56px;
      margin-left:12px;
    } 

    .alarm-div{
      margin-top:-10%;
      margin-left: 36%;
      width: 22vw;
      height:14vw;
      border-radius: 10px;
      justify-content: center;
      text-align: center; 
    } 
    
    .alarm-container {
      padding: 10px;
      border: 3px solid #ccc;
      border-radius: 10px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 24px;
      font-weight: bold;
     
    }
    
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px;
      border-radius: 9px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 21px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 17px;
      height: 17px;
      margin-right: 8px;
    }
    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 0.7rem 1.2rem;
      font-size: 22px;
      border: 2px solid #ddd;
      border-radius: 7px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:53px;
      padding: 0.5rem 1rem;
      font-size: 22px;
      border: 2px solid #ddd;
      border-radius: 7px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:-1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 23px; 
  }
     
}

@media only screen and (min-width: 2530px) {
  .plant-header {
    font-size: 41px;
    width: 30vw; 
    margin: 3; 
} 
.main-div {
  padding: 1.6rem; 
  width: 35vw;
  margin-top: -1%; 
  border-radius: 20px;
}
.item {
    background-color: white;
    padding: 1rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 22px;
    font-weight: bold;
    font-size: 34px;
}
  .main-div3 {
      margin-top: -27.5%; 
      width: 47vw; 
      
  }
  .flow-diagram{
    margin-top:-15%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-28%; 
    border-radius: 24px; 
       
     }
  .coal ,.co2, .ETP{
      font-size:24px;
      justify-content: center;
      text-align: center;
  }
  .env-header{
    font-size:30px;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 66px; 
      margin-top:12px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 15px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 72px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 94px; 
      margin-left:20px;
    }
    
    .EB-image-row img {
      width: 78px;
      height: 76px;
      margin-left:14px;
    } 

    .alarm-div{
      margin-top:-11%;
      margin-left: 36%;
      width: 22vw;
      height:18vw;
      
      border-radius: 12px;
      justify-content: center;
      text-align: center;
      
    }
    .alarm-container {
      padding: 15px;
      border: 4px solid #ccc;
      border-radius: 12px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 34px;
      font-weight: bold;
     
    }
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 27px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px;
      border-radius: 8px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 28px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 0.8rem 1.3rem;
      font-size: 32px;
      border: 3px solid #ddd;
      border-radius: 10px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:70px;
      padding: 0.5rem 1rem;
      font-size: 32px;
      border: 3px solid #ddd;
      border-radius: 8px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:0.1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 33px; 
  }
}

@media only screen and (min-width: 3796px) {

  .plant-header {
    font-size:62px;
    width: 30vw; 
    margin: 15; 
} 
.main-div {
  padding: 1.6rem; 
  width: 35vw;
  margin-top: 0.8%; 
  border-radius: 24px;
}
.item {
    background-color: white;
    padding: 2rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 32px;
    font-weight: bold;
    font-size: 52px;
}
  .main-div3 {
      margin-top: -26%; 
      width: 47vw; 
      
  }
  .flow-diagram{
    margin-top:-14%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-26%;  
    width: 22vw;
    height:10vw; 
    border-radius: 27px;   
     }
  .coal ,.co2, .ETP{
      font-size:37px;
      justify-content: center;
      text-align: center;
  }
  .env-header{
    font-size:44px;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 85px; 
      margin-top:18px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 28px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 100px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 140px; 
      margin-left:20px;
    }
    
    .EB-image-row img {
      width: 128px;
      height: 116px;
      margin-left:28px;
    } 

    .alarm-div{
      margin-top:-10%;
      margin-left: 36%;
      width: 22vw;
      height:15vw;
      border-radius: 10px;
      justify-content: center;
      text-align: center;
      
    }
    .alarm-container {
      padding: 25px;
      border: 6px solid #ccc;
      border-radius: 15px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 46px;
      font-weight: bold;
     
    }
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 28px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px;
      border-radius: 22px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 45px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 1.2rem 1.7rem;
      font-size: 47px;
      border: 5px solid #ddd;
      border-radius: 14px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:94px;
      padding: 0.6rem 1.2rem;
      font-size: 48px;
      border: 3px solid #ddd;
      border-radius: 8px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:0.1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 47px; 
  }  
}


@media only screen and (min-width: 5061px) {
  .plant-header {
    font-size:80px;
    width: 30vw; 
    margin: 15; 
} 
.main-div {
  padding: 1.6rem; 
  width: 35vw;
  margin-top: 1%; 
  border-radius: 28px;
}
.item {
    background-color: white;
    padding: 2rem; 
    text-align: center;
    width: 15vw; 
    min-height: 13vh; 
    border-radius: 32px;
    font-weight: bold;
    font-size: 70px;
}

  .main-div3 {
      margin-top: -23.8%; 
      width: 47vw; 
      height: 300px !important;
      
  }
  .flow-diagram{
    margin-top:-15%;
    margin-left: 60%;
    width: 38vw;
    height:20vw;
    background-color: white;
  }
  .env-benefits{
    margin-top:-28%;  
    width: 22vw;
    height:10vw;   
    border-radius: 34px;  
     }
  .coal ,.co2, .ETP{
      font-size:45px;
      justify-content: center;
      text-align: center;
  }
  .env-header{
    font-size:58px;
    margin:25px;
  }
  
  .values-row {
      display:flex;
      justify-content: center;
      text-align: center;
      gap: 150px; 
      margin-top:20px;
      font-weight: bold;
    
    }
    
    .text-row {
      display: flex;
      gap: 38px; 
      margin-top: 3px; 
      margin-left: 10px;
    }
    .text-row .co2{
      margin-left: 130px;
    }
    .text-row .ETP{
      margin-left: 34px;
    }
    .EB-image-row {
      display: flex;
      gap: 220px; 
      margin-left:38px;
    }
    
    .EB-image-row img {
      width: 158px;
      height: 146px;
      margin-left:28px;
    } 

    .alarm-div{
      margin-top:-9%;
      margin-left: 36%;
      width: 22vw;
      height:16vw;
      border-radius: 16px;
      justify-content: center;
      text-align: center;
      
    }
    .alarm-container {
      padding: 40px;
      border: 8px solid #ccc;
      border-radius: 32px;
      
    }
    
   
    .alarm-header h6 {
      font-size: 65px;
      font-weight: bold;
     
    }
    .alarm-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 28px;
    }
    
    .alarm-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 32px;
      border-radius: 18px;
      background-color: white;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
    
    .alarm-item span {
      font-size: 58px;
      font-weight: bold;
      color: #333;
    }
    
    .alarm-icon {
      width: 38px;
      height: 38px;
      margin-right: 18px;
    }
    .date-picker-container {
      display: flex;
      align-items: center;
      margin: 1rem 0;
  }
  
  .date-picker-label {
      font-weight: bold;
      margin-right: 1rem;
  }
  
  .styled-date-picker {
      padding: 1.3rem 1.8rem;
      font-size: 65px;
      border: 5px solid #ddd;
      border-radius: 14px;
    }
  
  .dropdown-container{
      margin-top: 1px;   
  }
  .styled-dropdown{
      height:125px;
      padding: 0.6rem 1.2rem;
      font-size: 65px;
      border: 3px solid #ddd;
      border-radius: 8px;
      background-color: white;
      cursor: pointer;
     
  }
  .date-picker-container,
  .dropdown-container {
      display: inline-block;
      margin-right: 10px; 
  }
  .energy-value-container {
      gap: 10px; 
      margin-top:0.1%;
  }
  
  .energy-value-container h6 {
      margin-left: 10%; 
      padding: 1;
      font-size: 67px; 
  } 

} */





`, "",{"version":3,"sources":["webpack://./src/components/Overview/LayoutOverview.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI,OAAO;IACP,OAAO;IACP,eAAe;;IAEf,cAAc;AAClB;AACA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;;AAEtB;;;;AAIA,mBAAmB;AACnB;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;;AAEnB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,mCAAmC;IACnC,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,mCAAmC;IACnC,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;;EAGA;IACE,eAAe;IACf,iBAAiB;;EAEnB;;EAEA;IACE,aAAa;;IAEb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,WAAW;IACX,sBAAsB;;EAExB;EACA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,WAAW;IACX,sBAAsB;;EAExB;;EAEA;IACE,eAAe;IACf,eAAe;KACd,WAAW;IACZ,UAAU;IACV,0CAA0C;IAC1C,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;KAEjB;KACA;MACC,aAAa;IACf,eAAe;KACd,WAAW;IACZ,UAAU;;IAEV,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;OAEf;;;MAGD;QACE,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb;kCAC0B;QAC1B,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;;MAGE;QACE,aAAa;QACb,SAAS;QACT,gBAAgB;MAClB;;MAEA;QACE,WAAW;QACX,YAAY;QACZ,eAAe;MACjB;;EAEJ;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;GACG,yCAAyC;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;EACE;IACE,UAAU;;EAEZ;;EAEA;IACE,WAAW;AACf;;EAEE;IACE,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,wCAAwC;IACxC,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;;;AAGnB;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;;AAEnB;AACA;;IAEI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;;;AAIA,UAAU;AACV;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,+BAA+B;IAC/B,aAAa;IACb,UAAU;;AAEd;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;;AAEvB;;;AAGA;EACE;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;;AAGA;EACE;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;;AAGA;EACE;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;AACA;EACE;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;;;AAGA;EACE;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;AACA;EACE;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA04BG","sourcesContent":["body, html {\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: #f0f0f0; \r\n}\r\n\r\n.main-container {\r\n    width: 100%;\r\n    height: calc(100vh - 80px); \r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: inherit; \r\n}\r\n \r\n.fixed-header {\r\n\r\n    left: 0;\r\n    top: 6%;\r\n    padding: 0.5rem; \r\n    \r\n    font-size:22px;\r\n}\r\n.plant-header {\r\n    font-size: 22px;\r\n    width: 30vw; \r\n    margin-bottom:1rem;\r\n\r\n} \r\n\r\n\r\n\r\n/* yield overview */\r\n.main-div {\r\n    padding: 1rem; \r\n    width: 58vw;\r\n    margin-top: -1%; \r\n    border-radius: 20px;\r\n    background-color:white;\r\n    display: flex;\r\n    justify-items: center;\r\n    align-items: center;\r\n}\r\n\r\n.card-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr); \r\n    gap: 1rem;\r\n    justify-items: center;\r\n    align-items: center;\r\n}\r\n\r\n.item1 {\r\n    background-color:#FBD1D1;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 13vw; \r\n    min-height: 12vh; \r\n    border-radius: 15px;\r\n    font-weight: bold;\r\n    font-size: 17px;\r\n    \r\n}\r\n\r\n.item2 {\r\n    background-color: blanchedalmond;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 13vw; \r\n    min-height: 12vh; \r\n    border-radius: 15px;\r\n    font-weight: bold;\r\n    font-size: 17px;\r\n}\r\n.item3 {\r\n    background-color:rgb(212, 243, 243);\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 13vw; \r\n    min-height: 12vh; \r\n    border-radius: 15px;\r\n    font-weight: bold;\r\n    font-size: 17px;\r\n}\r\n.item4 {\r\n    background-color:rgb(248, 231, 248);\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 13vw; \r\n    min-height: 12vh; \r\n    border-radius: 15px;\r\n    font-weight: bold;\r\n    font-size: 17px;\r\n}\r\n\r\n.alarm-div{\r\n    margin-top:1%;\r\n    margin-left: 1%;\r\n    width: 57vw;\r\n    height:28vw; \r\n    border-radius: 15px;\r\n    background-color: white;\r\n    justify-content: center;\r\n    text-align: center;\r\n  }\r\n\r\n  .alarm-container {\r\n    padding: 20px;\r\n    background-color: white; \r\n    border-radius: 15px;\r\n  }\r\n  \r\n \r\n  .alarm-header h6 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n   \r\n  }\r\n  \r\n  .alarm-grid {\r\n    display: grid;\r\n \r\n    grid-template-columns: repeat(4, 1fr); \r\n    gap: 15px;\r\n  }\r\n  \r\n  .alarm-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    background-color: #f0f0f0;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .alarm-item span {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: #333;\r\n  }\r\n  \r\n  .alarm-icon {\r\n    width: 15px;\r\n    height: 15px;\r\n    margin-right: 8px;\r\n  }\r\n  .flow-diagram{\r\n    margin-top:-24%;\r\n    margin-left: 4%;\r\n    width: 45vw;\r\n    height:20vw;\r\n    background-color:white;\r\n   \r\n  }\r\n  .flow-dgm{\r\n    margin-top:-1%;\r\n    margin-left: 1%;\r\n    width: 57vw;\r\n    height:29vw;\r\n    background-color:white;\r\n   \r\n  }\r\n \r\n  .env-benefits{\r\n    margin-top:4.5%;\r\n    margin-left: 1%;\r\n     width: 57vw;\r\n    height:7vw;\r\n    /* background-color: rgb(203, 252, 236); */\r\n    background-color: white;\r\n    border-radius: 15px;\r\n    justify-content: center;\r\n    text-align: center;\r\n        \r\n     }\r\n     .environ-benefits{\r\n      margin-top:1%;\r\n    margin-left: 1%;\r\n     width: 57vw;\r\n    height:7vw;\r\n \r\n    background-color: white;\r\n    border-radius: 15px;\r\n    justify-content: center;\r\n    text-align: center;\r\n          \r\n       }\r\n      \r\n\r\n      .env-header {\r\n        text-align: left;\r\n        margin-bottom: 1rem;\r\n        margin-left:2%;\r\n        font-size: 16px;\r\n        /* font-weight: bold; */\r\n    }\r\n    \r\n    .EB-container {\r\n        display: flex;\r\n        /* justify-content: space-between; \r\n        align-items: flex-start; */\r\n        gap: 6.4rem; \r\n    }\r\n    \r\n    .EB-item {\r\n        display: flex;\r\n        align-items: center;\r\n        gap:0.5rem; \r\n    }\r\n    \r\n    .values-column {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n    \r\n    .value {\r\n        font-size: 14px;\r\n        font-weight: bold;\r\n        margin-bottom: 0.2rem; \r\n    }\r\n    \r\n    .label {\r\n        font-size: 12px;\r\n        color: #555;\r\n    }\r\n    \r\n\r\n      .EB-image-row {\r\n        display: flex;\r\n        gap: 50px; \r\n        margin-left:10px;\r\n      }\r\n      \r\n      .EB-image-row img {\r\n        width: 50px;\r\n        height: 50px;\r\n        margin-left:1px;\r\n      } \r\n\r\n  .main-div2{\r\n    padding: 0.5rem; \r\n    width: 40vw;\r\n    margin-top: -46%;\r\n    margin-left: 47rem; \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n.main-temp{\r\n   /* background-color:rgb(129, 129, 228); */\r\n  background-color: #a8d5e4;\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n  padding:8px;\r\n  font-weight: bold;\r\n}\r\n.main-div3{\r\n    padding: 0.5rem;\r\n    margin-top:1.5%;\r\n    width: 40vw;\r\n    margin-left: 47rem;  \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n  .day-graph1{\r\n    width:100%;\r\n    \r\n  }\r\n\r\n  .chart-container {\r\n    width: 100%;\r\n}\r\n  \r\n  .date-picker-container {\r\n    display: flex;\r\n    align-items: center;\r\n  \r\n}\r\n\r\n.date-picker-label {\r\n    font-weight: bold;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.styled-date-picker {\r\n    padding: 0.1rem 2rem;\r\n    font-size: 14px;\r\n    border: 2px solid #ddd;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    transition: border-color 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.styled-date-picker:hover {\r\n    border-color: #999;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.styled-date-picker:focus {\r\n    outline: none;\r\n    border-color: #007bff;\r\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\r\n}\r\n\r\n.dropdown-container{\r\n    margin-top: 1px;\r\n    \r\n    \r\n}\r\n.styled-dropdown{\r\n    height:30px;\r\n    padding: 0.1rem 2rem;\r\n    font-size: 14px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n   \r\n}\r\n.date-picker-container,\r\n.dropdown-container {\r\n    display: inline-block;\r\n    margin-right: 10px; \r\n}\r\n\r\n.date-picker-dropdown-container {\r\n    display: flex;\r\n    align-items: center; \r\n}\r\n\r\n\r\n\r\n/* graph */\r\n.energy-value-container {\r\n    display: flex;\r\n    flex-direction: row; \r\n    align-items: center; \r\n    gap: 10px; \r\n    /* background-color: #f0f0f0; */\r\n    margin-top:1%;\r\n    color:blue;\r\n    \r\n}\r\n\r\n.energy-value-container h6 {\r\n    margin-left: 6%; \r\n    padding: 1px;\r\n    font-size: 15px;\r\n    font-weight:bold; \r\n}\r\n\r\n.energy-value-container .energy-label {\r\n\r\n    font-weight: normal; \r\n    \r\n}\r\n\r\n\r\n@media only screen and (min-width: 1403px) {\r\n  .main-div2{\r\n    padding: 0.5rem; \r\n    width: 40vw;\r\n    margin-top: -46%;\r\n    margin-left: 52rem; \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n.main-div3{\r\n    padding: 0.5rem;\r\n    margin-top:1.4%;\r\n    width: 40vw;\r\n    margin-left: 52rem;  \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n\r\n}\r\n\r\n\r\n@media only screen and (min-width: 1540px) {\r\n  .main-div2{\r\n    padding: 0.5rem; \r\n    width: 40vw;\r\n    margin-top: -45%;\r\n    margin-left: 59rem; \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n.main-div3{\r\n    padding: 0.5rem;\r\n    margin-top:1.4%;\r\n    width: 40vw;\r\n    margin-left: 59rem;  \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n\r\n}\r\n\r\n\r\n@media only screen and (min-width: 1684px) {\r\n  .main-div2{\r\n    padding: 0.5rem; \r\n    width: 40vw;\r\n    margin-top: -45%;\r\n    margin-left: 62.5rem; \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n.main-div3{\r\n    padding: 0.5rem;\r\n    margin-top:1.2%;\r\n    width: 40vw;\r\n    margin-left: 62.5rem;  \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n\r\n}\r\n@media only screen and (min-width: 1874px) {\r\n  .main-div2{\r\n    padding: 0.5rem; \r\n    width: 40vw;\r\n    margin-top: -45%;\r\n    margin-left: 70.5rem; \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n.main-div3{\r\n    padding: 0.5rem;\r\n    margin-top:1.2%;\r\n    width: 40vw;\r\n    margin-left:70.5rem;  \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n}\r\n\r\n\r\n@media only screen and (min-width: 2530px) {\r\n  .main-div2{\r\n    padding: 0.5rem; \r\n    width: 40vw;\r\n    margin-top: -45%;\r\n    margin-left: 94rem; \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n.main-div3{\r\n    padding: 0.5rem;\r\n    margin-top:1.2%;\r\n    width: 40vw;\r\n    margin-left: 94rem;  \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n\r\n}\r\n\r\n@media only screen and (min-width: 3796px) {\r\n  .main-div2{\r\n    padding: 0.5rem; \r\n    width: 40vw;\r\n    margin-top: -42%;\r\n    margin-left: 140rem; \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n.main-div3{\r\n    padding: 0.5rem;\r\n    margin-top:1.2%;\r\n    width: 40vw;\r\n    margin-left: 140rem;  \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n\r\n}\r\n@media only screen and (min-width: 5061px) {\r\n  .main-div2{\r\n    padding: 0.5rem; \r\n    width: 40vw;\r\n    margin-top: -42%;\r\n    margin-left: 188rem; \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n.main-div3{\r\n    padding: 0.5rem;\r\n    margin-top:1.2%;\r\n    width: 40vw;\r\n    margin-left: 188rem;  \r\n    background-color:white;\r\n    border-radius: 15px;\r\n}\r\n\r\n}\r\n\r\n\r\n\r\n/* \r\n\r\n@media only screen and (min-width: 1684px) {\r\n  \r\n  .plant-header {\r\n    font-size: 28px;\r\n    width: 30vw; \r\n    margin: 0; \r\n} \r\n.main-div {\r\n  padding: 1.2rem; \r\n  width: 35vw;\r\n  margin-top: -1%; \r\n  border-radius: 20px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 20px;\r\n    font-weight: bold;\r\n    font-size: 24px;\r\n}\r\n\r\n.main-div3 {\r\n  margin-top: -29.5%; \r\n  width: 47vw; \r\n}\r\n\r\n.env-benefits{\r\n  margin-top:-20%; \r\n  border-radius: 20px;     \r\n   }\r\n.coal ,.co2, .ETP{\r\n    font-size:14px;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\n.values-row {\r\n    display:flex;\r\n    justify-content: center;\r\n    text-align: center;\r\n    gap: 60px; \r\n    margin-top:5px;\r\n    font-weight: bold;\r\n  \r\n  }\r\n  \r\n  .text-row {\r\n    display: flex;\r\n    gap: 14px; \r\n    margin-top: 3px; \r\n    margin-left: 10px;\r\n  }\r\n  .text-row .co2{\r\n    margin-left: 60px;\r\n  }\r\n  .text-row .ETP{\r\n    margin-left: 38px;\r\n  }\r\n  .EB-image-row {\r\n    display: flex;\r\n    gap: 64px; \r\n    margin-left:20px;\r\n  }\r\n  \r\n  .EB-image-row img {\r\n    width: 52px;\r\n    height: 50px;\r\n    margin-left:10px;\r\n  } \r\n  .alarm-div{\r\n    margin-top:-10%;\r\n    margin-left: 36%;\r\n    width: 22vw;\r\n    height:9vw;\r\n    \r\n    border-radius: 12px;\r\n    justify-content: center;\r\n    text-align: center;\r\n    \r\n  }\r\n  .alarm-container {\r\n    padding: 3px;\r\n    border: 3px solid #ccc;\r\n    border-radius: 10px;\r\n    \r\n  }\r\n  \r\n \r\n  .alarm-header h6 {\r\n    font-size: 21px;\r\n    font-weight: bold;\r\n   \r\n  }\r\n  \r\n  .alarm-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 18px;\r\n  }\r\n  \r\n  .alarm-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 12px;\r\n    border-radius: 9px;\r\n    background-color: white;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .alarm-item span {\r\n    font-size: 19px;\r\n    font-weight: bold;\r\n    color: #333;\r\n  }\r\n  \r\n  .alarm-icon {\r\n    width: 17px;\r\n    height: 17px;\r\n    margin-right: 9px;\r\n  }\r\n\r\n  .date-picker-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 1rem 0;\r\n}\r\n\r\n.date-picker-label {\r\n    font-weight: bold;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.styled-date-picker {\r\n    padding: 0.7rem 1.2rem;\r\n    font-size: 22px;\r\n    border: 2px solid #ddd;\r\n    border-radius: 7px;\r\n  }\r\n\r\n.dropdown-container{\r\n    margin-top: 1px;   \r\n}\r\n.styled-dropdown{\r\n    height:53px;\r\n    padding: 0.5rem 1rem;\r\n    font-size: 22px;\r\n    border: 2px solid #ddd;\r\n    border-radius: 7px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n   \r\n}\r\n.date-picker-container,\r\n.dropdown-container {\r\n    display: inline-block;\r\n    margin-right: 10px; \r\n}\r\n.energy-value-container {\r\n    gap: 10px; \r\n    margin-top:-1%;\r\n}\r\n\r\n.energy-value-container h6 {\r\n    margin-left: 10%; \r\n    padding: 1;\r\n    font-size: 22px; \r\n}\r\n\r\n}\r\n\r\n@media only screen and (min-width: 1874px) {\r\n\r\n  .plant-header {\r\n    font-size: 29px;\r\n    width: 30vw; \r\n    margin: 0; \r\n} \r\n.main-div {\r\n  padding: 1.2rem; \r\n  width: 35vw;\r\n  margin-top: -1%; \r\n  border-radius: 20px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 20px;\r\n    font-weight: bold;\r\n    font-size: 25px;\r\n}\r\n  .main-div3 {\r\n      margin-top: -31.5%; \r\n      width: 47vw; \r\n    \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-16%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-25%;  \r\n    border-radius: 22px;\r\n       \r\n     }\r\n  .coal ,.co2, .ETP{\r\n      font-size:17px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  .env-header{\r\n    font-size:24px;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 60px; \r\n      margin-top:5px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 12px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 58px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 65px; \r\n      margin-left:20px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 58px;\r\n      height: 56px;\r\n      margin-left:12px;\r\n    } \r\n\r\n    .alarm-div{\r\n      margin-top:-10%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:14vw;\r\n      border-radius: 10px;\r\n      justify-content: center;\r\n      text-align: center; \r\n    } \r\n    \r\n    .alarm-container {\r\n      padding: 10px;\r\n      border: 3px solid #ccc;\r\n      border-radius: 10px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 24px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    \r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 24px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 14px;\r\n      border-radius: 9px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 21px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 17px;\r\n      height: 17px;\r\n      margin-right: 8px;\r\n    }\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 0.7rem 1.2rem;\r\n      font-size: 22px;\r\n      border: 2px solid #ddd;\r\n      border-radius: 7px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:53px;\r\n      padding: 0.5rem 1rem;\r\n      font-size: 22px;\r\n      border: 2px solid #ddd;\r\n      border-radius: 7px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:-1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 23px; \r\n  }\r\n     \r\n}\r\n\r\n@media only screen and (min-width: 2530px) {\r\n  .plant-header {\r\n    font-size: 41px;\r\n    width: 30vw; \r\n    margin: 3; \r\n} \r\n.main-div {\r\n  padding: 1.6rem; \r\n  width: 35vw;\r\n  margin-top: -1%; \r\n  border-radius: 20px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 1rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 22px;\r\n    font-weight: bold;\r\n    font-size: 34px;\r\n}\r\n  .main-div3 {\r\n      margin-top: -27.5%; \r\n      width: 47vw; \r\n      \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-15%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-28%; \r\n    border-radius: 24px; \r\n       \r\n     }\r\n  .coal ,.co2, .ETP{\r\n      font-size:24px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  .env-header{\r\n    font-size:30px;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 66px; \r\n      margin-top:12px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 15px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 72px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 94px; \r\n      margin-left:20px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 78px;\r\n      height: 76px;\r\n      margin-left:14px;\r\n    } \r\n\r\n    .alarm-div{\r\n      margin-top:-11%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:18vw;\r\n      \r\n      border-radius: 12px;\r\n      justify-content: center;\r\n      text-align: center;\r\n      \r\n    }\r\n    .alarm-container {\r\n      padding: 15px;\r\n      border: 4px solid #ccc;\r\n      border-radius: 12px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 34px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 27px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 14px;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 28px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 18px;\r\n      height: 18px;\r\n      margin-right: 8px;\r\n    }\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 0.8rem 1.3rem;\r\n      font-size: 32px;\r\n      border: 3px solid #ddd;\r\n      border-radius: 10px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:70px;\r\n      padding: 0.5rem 1rem;\r\n      font-size: 32px;\r\n      border: 3px solid #ddd;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:0.1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 33px; \r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 3796px) {\r\n\r\n  .plant-header {\r\n    font-size:62px;\r\n    width: 30vw; \r\n    margin: 15; \r\n} \r\n.main-div {\r\n  padding: 1.6rem; \r\n  width: 35vw;\r\n  margin-top: 0.8%; \r\n  border-radius: 24px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 2rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 32px;\r\n    font-weight: bold;\r\n    font-size: 52px;\r\n}\r\n  .main-div3 {\r\n      margin-top: -26%; \r\n      width: 47vw; \r\n      \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-14%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-26%;  \r\n    width: 22vw;\r\n    height:10vw; \r\n    border-radius: 27px;   \r\n     }\r\n  .coal ,.co2, .ETP{\r\n      font-size:37px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  .env-header{\r\n    font-size:44px;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 85px; \r\n      margin-top:18px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 28px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 100px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 140px; \r\n      margin-left:20px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 128px;\r\n      height: 116px;\r\n      margin-left:28px;\r\n    } \r\n\r\n    .alarm-div{\r\n      margin-top:-10%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:15vw;\r\n      border-radius: 10px;\r\n      justify-content: center;\r\n      text-align: center;\r\n      \r\n    }\r\n    .alarm-container {\r\n      padding: 25px;\r\n      border: 6px solid #ccc;\r\n      border-radius: 15px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 46px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 28px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 30px;\r\n      border-radius: 22px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 45px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 28px;\r\n      height: 28px;\r\n      margin-right: 10px;\r\n    }\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 1.2rem 1.7rem;\r\n      font-size: 47px;\r\n      border: 5px solid #ddd;\r\n      border-radius: 14px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:94px;\r\n      padding: 0.6rem 1.2rem;\r\n      font-size: 48px;\r\n      border: 3px solid #ddd;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:0.1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 47px; \r\n  }  \r\n}\r\n\r\n\r\n@media only screen and (min-width: 5061px) {\r\n  .plant-header {\r\n    font-size:80px;\r\n    width: 30vw; \r\n    margin: 15; \r\n} \r\n.main-div {\r\n  padding: 1.6rem; \r\n  width: 35vw;\r\n  margin-top: 1%; \r\n  border-radius: 28px;\r\n}\r\n.item {\r\n    background-color: white;\r\n    padding: 2rem; \r\n    text-align: center;\r\n    width: 15vw; \r\n    min-height: 13vh; \r\n    border-radius: 32px;\r\n    font-weight: bold;\r\n    font-size: 70px;\r\n}\r\n\r\n  .main-div3 {\r\n      margin-top: -23.8%; \r\n      width: 47vw; \r\n      height: 300px !important;\r\n      \r\n  }\r\n  .flow-diagram{\r\n    margin-top:-15%;\r\n    margin-left: 60%;\r\n    width: 38vw;\r\n    height:20vw;\r\n    background-color: white;\r\n  }\r\n  .env-benefits{\r\n    margin-top:-28%;  \r\n    width: 22vw;\r\n    height:10vw;   \r\n    border-radius: 34px;  \r\n     }\r\n  .coal ,.co2, .ETP{\r\n      font-size:45px;\r\n      justify-content: center;\r\n      text-align: center;\r\n  }\r\n  .env-header{\r\n    font-size:58px;\r\n    margin:25px;\r\n  }\r\n  \r\n  .values-row {\r\n      display:flex;\r\n      justify-content: center;\r\n      text-align: center;\r\n      gap: 150px; \r\n      margin-top:20px;\r\n      font-weight: bold;\r\n    \r\n    }\r\n    \r\n    .text-row {\r\n      display: flex;\r\n      gap: 38px; \r\n      margin-top: 3px; \r\n      margin-left: 10px;\r\n    }\r\n    .text-row .co2{\r\n      margin-left: 130px;\r\n    }\r\n    .text-row .ETP{\r\n      margin-left: 34px;\r\n    }\r\n    .EB-image-row {\r\n      display: flex;\r\n      gap: 220px; \r\n      margin-left:38px;\r\n    }\r\n    \r\n    .EB-image-row img {\r\n      width: 158px;\r\n      height: 146px;\r\n      margin-left:28px;\r\n    } \r\n\r\n    .alarm-div{\r\n      margin-top:-9%;\r\n      margin-left: 36%;\r\n      width: 22vw;\r\n      height:16vw;\r\n      border-radius: 16px;\r\n      justify-content: center;\r\n      text-align: center;\r\n      \r\n    }\r\n    .alarm-container {\r\n      padding: 40px;\r\n      border: 8px solid #ccc;\r\n      border-radius: 32px;\r\n      \r\n    }\r\n    \r\n   \r\n    .alarm-header h6 {\r\n      font-size: 65px;\r\n      font-weight: bold;\r\n     \r\n    }\r\n    .alarm-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 28px;\r\n    }\r\n    \r\n    .alarm-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      padding: 32px;\r\n      border-radius: 18px;\r\n      background-color: white;\r\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .alarm-item span {\r\n      font-size: 58px;\r\n      font-weight: bold;\r\n      color: #333;\r\n    }\r\n    \r\n    .alarm-icon {\r\n      width: 38px;\r\n      height: 38px;\r\n      margin-right: 18px;\r\n    }\r\n    .date-picker-container {\r\n      display: flex;\r\n      align-items: center;\r\n      margin: 1rem 0;\r\n  }\r\n  \r\n  .date-picker-label {\r\n      font-weight: bold;\r\n      margin-right: 1rem;\r\n  }\r\n  \r\n  .styled-date-picker {\r\n      padding: 1.3rem 1.8rem;\r\n      font-size: 65px;\r\n      border: 5px solid #ddd;\r\n      border-radius: 14px;\r\n    }\r\n  \r\n  .dropdown-container{\r\n      margin-top: 1px;   \r\n  }\r\n  .styled-dropdown{\r\n      height:125px;\r\n      padding: 0.6rem 1.2rem;\r\n      font-size: 65px;\r\n      border: 3px solid #ddd;\r\n      border-radius: 8px;\r\n      background-color: white;\r\n      cursor: pointer;\r\n     \r\n  }\r\n  .date-picker-container,\r\n  .dropdown-container {\r\n      display: inline-block;\r\n      margin-right: 10px; \r\n  }\r\n  .energy-value-container {\r\n      gap: 10px; \r\n      margin-top:0.1%;\r\n  }\r\n  \r\n  .energy-value-container h6 {\r\n      margin-left: 10%; \r\n      padding: 1;\r\n      font-size: 67px; \r\n  } \r\n\r\n} */\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
